export const subtitle = (theme, gutterBottom = true) => ({
    subtitle: {
        color: theme.palette.secondary.dark,
        marginBottom: gutterBottom ? theme.spacing(2) : 0
    }
});

export const containedButton = (theme, fullWidth = true, gutterBottom = true) => ({
    containedButton: {
        width: fullWidth ? '100%' : 'initial',
        backgroundColor: theme.palette.tertiary.main,
        color: '#fff',
        marginBottom: gutterBottom ? theme.spacing(2) : 0,
        '&:hover': {
            backgroundColor: theme.palette.tertiary.dark
        }
    }
});

export const outlinedButton = (theme, fullWidth = true, gutterBottom = true) => ({
    outlinedButton: {
        width: fullWidth ? '100%' : 'initial',
        backgroundColor: 'transparent',
        borderColor: theme.palette.tertiary.main,
        color: theme.palette.tertiary.main,
        marginBottom: gutterBottom ? theme.spacing(2) : 0
    }
});

export const textButton = (theme, fullWidth = true) => ({
    textButton: {
        width: fullWidth ? '100%' : 'initial',
        color: theme.palette.tertiary.main
    }
});

export const menuButton = theme => ({
    menuButton: {
        color: theme.palette.primary.light/* + ' !important'*/,
        height: 64,
        borderRadius: 0,
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        transition: 'none',
        borderBottom: 0,
        '&.selected': {
            height: 64,
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            borderBottom: '4px solid' + theme.palette.primary.main,
            transition: 'border 0.2s ease-in'
        }
    }
});

export const buttonTableCell = (theme, width = 150) => ({
    buttonTableCell: {
        width: width
    }
});

/*
 * Título de bloco dentro das seções do formulário. Mesma tipografia do título
 * dos cards da tela do inscrito ("Vaga escolhida", "Resumo da inscrição"),
 * que usam <Typography variant="h6">.
 */
export const tituloSecao = theme => ({
    ...theme.typography.h6,
    color: theme.palette.primary.main
});

export const menuTableCell = (theme, width = 50) => ({
    menuTableCell: {
        width: width
    }
});

export const pageMargin = theme => ({
    margin: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3)
    }
});

export const containerPaper = theme => ({
    containerPaper: {
        padding: theme.spacing(3)
    }
});

export const backgroundMenu = theme => ({
    backgroundMenu :{
        display: 'flex',
        padding: theme.spacing(1, 2),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.secondary.light,
        borderRadius: theme.shape.borderRadius
    }
});